/* eslint-disable quotes */
// import 'core-js/fn/array/includes';
// import 'core-js/fn/array/find';
import unorphan from 'unorphan';
import Scrollbar, { ScrollbarPlugin } from 'smooth-scrollbar';
import OverscrollPlugin from 'smooth-scrollbar/plugins/overscroll';
// import AutoPlayVideo from './AutoPlayVideo';
import { picoapp } from 'picoapp';
import GridSizer from './GridSizer';
import NewsLetter from './NewsLetter';
import Product from './Product';
import accounts from './accounts';
import cart from './cart';
import help from './help';
import threeDimensionalSlider from './ThreeDimensionalSlider';
import CountDown from './CountDown';
import plusDigitalGridItems from './plus-digital-grid-items';
import sectionCartUpsell from './section-cart-upsell';
import NewsLetterDraft from './NewsLetterDraft';
import hoverShowSecondImage from './hover-show-second-image';
import cartDrawer from './cart-drawer';
import freshworksTrigger from './components/freshworksTrigger';
import multiRaffleProduct from './components/multi-raffle-product';
import multiRaffleForm from './components/multi-raffle-form';
import buyAll from './components/buy-all';
import filters from './components/filters';
import regionalDescription from './components/regional-description';

const app = picoapp({
  multiRaffleProduct,
  multiRaffleForm,
  buyAll,
  filters,
  regionalDescription,
});
// import 'what-input';

const TRAVIS = window.TRAVIS || {};
const body = document.getElementsByTagName('body')[0];
body.classList.add('js-body-ready');
setTimeout(() => body.classList.add('js-ready'), 100);

cartDrawer.init();

// do once
(() => {
  [...document.querySelectorAll('.js-newsletter')].map((el) => new NewsLetter(el));
  [...document.querySelectorAll('.js-newsletter-draft')].map((el) => new NewsLetterDraft(el));
  unorphan(document.querySelectorAll('.js-unorphan'), { br: true });
  // trackingProduct();
})();

const doProduct = () => {
  [...document.querySelectorAll('.js-product')].forEach((prod, i) => {
    const theP = new Product(prod);
    theP.show();
  });
};

const doCollection = () => {
  hoverShowSecondImage();
  plusDigitalGridItems();

  if (TRAVIS.doProduct) {
    // body.classList.remove('template-index');
    // body.classList.remove('template-collection');
    // body.classList.add('template-product');
    const gridSizer = new GridSizer();
    gridSizer.init();
    if (window.scrollY) {
      setTimeout(() => {
        window.scroll(0, 0); // reset the scroll position to the top left of the document.
      }, 3);
    }
    return doProduct();
  }
  const gridSizer = new GridSizer();
  gridSizer.init();
  body.classList.add('js-show-header');
};

const doCollectionRoute = () => {
  const id = TRAVIS.collection;
  return doCollection(id);
};

// const doVideo = (num) => {
//   console.log('doVideo ' + num);
//   const v = document.getElementById('js-video');
//   if (!v) return;
//   v.onclick = () => (v.paused ? v.play() : v.pause());
// };

const lerp = (x, y, a) => x * (1 - a) + y * a;
const easeOutLerp = (x, y, a) => {
  const t = 1 - Math.pow(1 - a, 2); // Applying the easeOut easing effect
  return x * (1 - t) + y * t;
};

class HorizontalScrollPlugin extends ScrollbarPlugin {
  static pluginName = 'horizontalScroll';

  transformDelta(delta, fromEvent) {
    if (!/wheel/.test(fromEvent.type)) {
      return delta;
    }

    const { x, y } = delta;

    return {
      y: 0,
      x: Math.abs(x) > Math.abs(y) ? x : y,
    };
  }
}

// Scrollbar.use(OverscrollPlugin);
Scrollbar.use(HorizontalScrollPlugin);

const doHomepage = () => {
  const wrapper = document.querySelector('.FullScreen__logo');
  const logo = document.querySelector('.FullScreen__logo_image');
  const topBar = document.querySelector('.TopBar') || { offsetHeight: 0 };

  // document.querySelectorAll('a').forEach((link) => {
  //   link.addEventListener('click', (e) => {
  //     e.preventDefault();
  //     body.classList.remove('js-ready');
  //     setTimeout(() => {
  //       window.location.href = link.href;
  //     }, 800);
  //   });
  // });

  const setHorizontalScrollAreas = () => {
    document.querySelectorAll('.HorizontalItems').forEach((area) => {
      const items = area.querySelectorAll('.HorizontalItem');
      const isMobile = window.innerWidth <= 500;
      const wrapper = area.querySelector('.js-wrapper');
      const itemWidth = isMobile ? window.innerWidth * 0.8 : window.innerWidth / 4;

      wrapper.style.width = `${items.length * itemWidth}px`;

      items.forEach((item) => {
        item.style.width = `${itemWidth}px`;
      });

      Scrollbar.init(area, {
        alwaysShowTracks: true,
        damping: isMobile ? 0.2 : 0.5,
        overscroll: false,
      });
    });
  };

  setHorizontalScrollAreas();

  if (logo) {
    logo.addEventListener('click', (e) => {
      e.preventDefault();
      scroll({
        top: window.innerHeight,
        behavior: 'smooth',
      });
    });

    const calculateTop = (_percent) => {
      const percent = _percent <= 0 ? 0 : _percent;
      const logoHeight = document.querySelector('.FullScreen__logo').offsetHeight;
      const top = (window.innerHeight - logoHeight) / 2 + topBar.offsetHeight;
      const offset = window.innerWidth < 500 ? 35 : 25;
      const minimum = offset + topBar.offsetHeight;

      wrapper.style.top = `${easeOutLerp(minimum, top, percent)}px`;
    };

    const calculateScale = (_percent) => {
      const percent = 1 - _percent >= 1 ? 1 : 1 - _percent;
      const { min } = logo.dataset;
      let _min = window.innerWidth < 640 ? min * 1 : min;
      const targetScale = _min / document.querySelector('.FullScreen__logo').offsetWidth;

      wrapper.style.transform = `translateX(-50%) scale(${easeOutLerp(1, targetScale, percent)})`;
    };

    const applyStyles = () => {
      const percent = 1 - window.scrollY / (window.innerHeight - 25);
      const logoHeight = document.querySelector('.FullScreen__logo').offsetHeight;

      calculateScale(percent);
      calculateTop(percent);
    };

    setTimeout(() => {
      applyStyles();
    }, 0);

    logo.addEventListener('load', applyStyles);

    window.addEventListener('resize', () => {
      applyStyles();
      setHorizontalScrollAreas();
    });

    window.addEventListener('scroll', () => {
      window.requestAnimationFrame(applyStyles);
    });
  }
};

const spinner = document.querySelector('.js-product-spinner');

const routes = {
  template_cart: () => {
    cart();
    [...document.querySelectorAll('.js-cart-upsell')].forEach(sectionCartUpsell);
  },
  template_index: () => {
    doCollectionRoute();
    if (spinner) threeDimensionalSlider();
    // Initialize global countdown (old snippet)
    new CountDown();
    // Initialize section-based countdowns
    [...document.querySelectorAll('.js-countdown-section')].forEach((el) => {
      new CountDown(el);
    });
    doHomepage();
    // new AutoPlayVideo(document.querySelector('.js-home-video'));
  },
  template_product: () => {
    // Initialize global countdown (old snippet)
    new CountDown();
    // Initialize section-based countdowns
    [...document.querySelectorAll('.js-countdown-section')].forEach((el) => {
      new CountDown(el);
    });
    doProduct();
  },
  template_product_multicolor: doProduct,
  template_collection: doCollectionRoute,
  template_customers_addresses: accounts,
  template_customers_login: accounts,
  template_customers_register: accounts,
  template_customers_account: accounts,
  template_page_help: help,
};

const fire = (func, args) => {
  let f;
  f = func !== '';
  f = f && routes[func];
  f = f && typeof routes[func] === 'function';
  if (f) routes[func](args);
  body.classList.add('js-body-ready');
  app.mount();
};

document.body.className
  .replace(/-/g, '_')
  .split(/\s+/)
  .forEach((classnm) => {
    // console.log('classnm: ', classnm);
    fire(classnm);
  });

// quick fix on links height
const topbar = document.querySelector('.js-topbar');
const toplinks = [...document.querySelectorAll('.js-toplink')];
const resize = () => {
  toplinks.forEach((el) => {
    el.style.top = `${topbar.offsetHeight}px`;
  });
};
if (topbar) {
  resize();
  window.addEventListener('resize', resize);
}

freshworksTrigger();

// Shopify theme editor: reinitialize countdowns when section settings change
if (window.Shopify && window.Shopify.designMode) {
  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target;
    [...section.querySelectorAll('.js-countdown-section')].forEach((el) => {
      new CountDown(el);
    });
  });

  document.addEventListener('shopify:section:reorder', () => {
    // Reinitialize all countdowns after section reordering
    [...document.querySelectorAll('.js-countdown-section')].forEach((el) => {
      new CountDown(el);
    });
  });
}

console.log(
  [
    ``,
    `                       ,l'`,
    `                       cM'                                          kl'`,
    `             ;         ,M.                .MNOo'                    0W.'`,
    `             ;0        'M'                 'oWXMWx.    ..;:lc;    'xo.'`,
    `             .W         Mc                 ,WMc :KMO,KWMMNxc;      cMK     .'`,
    `             ;K         O0                 WWXOl  ,NM0dKM,     .;ookx,  'KMMWx;'`,
    `             Kl         ;M.                XN;ko   .NN.0Mxdk0WWKl..XO   NMWdXMMd,.'`,
    `  .         oK          .M;     ..',;::;;. cMO.     dMlOMMKd:.    .MM;  xMMMM00MMMWo'`,
    `           x0.      ..,:lWX0KNWMWXK0kxdl;.  ;XMk;. ;NMcoM;         WM.   .'..   .,::'`,
    `   .:    ;Kl  'x0XWMWX0kdW0,'.                ,xWMMMN: ,Mc         'O;'`,
    `     codk:    ,o:,..     Xo                      .:'    Md'`,
    `                         No                             KX'`,
    `                         Wo                             dM.'`,
    `                         No                             ,Mx'`,
    `                         Ko                              kMl'`,
    `                         kk                               xN'`,
    `                         oX'`,
    `                         .M.'`,
    `                          0O'`,
    `                          ,M;'`,
    `                           lx'`,
  ].join(`\n`)
);

// console.log('\n\nbuiltbylane.com x davidbaker.tv ϟ made in brooklyn\n\n\n');
